import { writable } from 'svelte/store';

const coordinates = writable([[], []]);

const stoppingFeature = writable(null);
const startLocation = writable(null);

// Toggle for showing historical imperial province boundaries (true = imperial/1974, false = ethnic/2026)
const showImperialBoundaries = writable(true);

// Currently selected province for river display
const selectedProvince = writable(null);

export { coordinates, stoppingFeature, startLocation, showImperialBoundaries, selectedProvince };
